export default {"src":"/_next/static/media/0x86ed939B500E121C0C5f493F399084Db596dAd20.f729f936.svg","height":250,"width":250,"blurWidth":0,"blurHeight":0};